export default {
  data() {
    return {
      old: null,
      items: null,
      id: null
    };
  },
  methods: {
    applyOptimistic(items, id, changes) {
      if (!this.$store.state.commonStore.online) return;

      var item = items.find(e => e.id === id);
      if (!item) return;
      this.items = items;
      this.id = id;
      this.old = {};
      this.changes = changes;
      for (var property in changes) {
        if (changes.hasOwnProperty(property)) {
          this.old[property] = item[property];
          item[property] = changes[property];
        }
      }
    },
    cancelOptimistic() {
      if (!this.items) return;
      if (this.id === "new") {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].id === "new") {
            this.items.splice(i, 1);
            return;
          }
        }
      }
      var item = this.items.find(e => e.id === this.id);
      if (!item) return;
      for (var property in this.old) {
        if (this.old.hasOwnProperty(property)) {
          item[property] = this.old[property];
        }
      }
    }
  }
};
